import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['fieldset', 'topRole']

  change() {
    const selectedTopRole = this.topRoleTargets.find(
      radio => radio.checked
    )?.value

    this.fieldsetTargets.forEach(fieldset => {
      const isSelected =
        fieldset.dataset.roleGroupsGroupValue === selectedTopRole

      fieldset.disabled = !isSelected
    })
  }
}
